import { Directive, ElementRef, inject, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appReadonly]',
  standalone: true
})
/**
 * Begründung: Dies ist eine Directive um Frontendseitige divs nicht editierbar zu machen.
 */
export class ReadonlyDirective {
  el = inject(ElementRef);
  renderer = inject(Renderer2);
  constructor() {
    this.renderer.setAttribute(this.el.nativeElement, 'contenteditable', 'false');
  }
}
